const prefix = "PROFILES::";

export const SET_LOADING = `${prefix}SET_LOADING`;
export const SET_LIST = `${prefix}SET_LIST`;
export const UPDATE = `${prefix}UPDATE`;
export const APPEND_LIST = `${prefix}APPEND_LIST`;
export const UPDATE_IN_SELECTED = `${prefix}UPDATE_IN_SELECTED`;
export const DELETE_FROM_SELECTED = `${prefix}DELETE_FROM_SELECTED`;